import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const PasswordSection = () => {
  const { t } = useTranslation('editUser')
  const form = useForm()
  const { handleChange } = useFormState()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="50%" wrapOn="sm">
        <FormItem label={t('temporaryPassword')} field="password" autocomplete="none" type="password" />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem
          label={t('temporaryPasswordConfirmation')}
          field="passwordConfirmation"
          autocomplete="none"
          type="password"
        />
      </Col>
    </Grid>
  )
}

export default PasswordSection
